module.exports = __webpack_public_path__ + "img/everyday-heroes-bg.c6dd3271.jpg";